import React from 'react';
import './TeleCalling.css';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import { useCallContext } from './useCallContext';
import CallerActionableTabs from './components/CallerActionableTabs';
export { default as CustomerContextDetails } from './components/CustomerContextDetails';


const CallerContextPanel = ({ callerContext, isLoading }) => {
    const internationalise = useSelector((state) => state?.internationalise?.currentHashMapData);
    const { minimize } = useCallContext();

    if (isLoading) {
        return null;
    }

    return (
        <Box className="tc-context-panel">
            <CallerActionableTabs
                callerContext={callerContext}
                internationalise={internationalise}
                minimize={minimize}
            />
        </Box>
    );
};

export default CallerContextPanel;
